import {Component, OnInit} from '@angular/core';
import {ModalInterface} from "../modal-basic/ModalInterface";
import {DomSanitizer} from "@angular/platform-browser";
import {NgxUiLoaderService} from "ngx-ui-loader";

@Component({
    selector: 'app-popup-visor-pdf',
    templateUrl: './popup-visor-pdf.component.html'
})
export class PopupVisorPdfComponent extends ModalInterface implements OnInit {

    mostrarVisor: boolean;
    src: any;
    cargoVisor: boolean;
    
    constructor(
        private sanitized: DomSanitizer,
        private readonly cargandoService: NgxUiLoaderService,
    ) {
        super();
        this.mostrarVisor = true;
    }

    ngOnInit() {
        this.src = this.data.url;
        this.cargandoService.start();
    }

    onError(event) {
        this.mostrarVisor = false;
        this.cargoVisor = true;
        this.cargandoService.stop();
    }

    onLoadComplete() {
        this.cargoVisor = true;
        this.cargandoService.stop();
    }

    descargarArchivo(url: string) {
        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', url);
        link.setAttribute('download', this.data.nombreArchivo ? `${this.data.nombreArchivo}.pdf` : `factura.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
}
